import React from "react";

const Item = ({stuff, setGiftOpened}) => {

    console.log(stuff);

    const percentage = Math.trunc((stuff.tally / stuff.baseScore) * 100) || 0;

    return (
        <>
          <div className="item_main" style={{background: `linear-gradient(to right, ${stuff.color} 0%, ${stuff.color} ${percentage}%, transparent ${percentage}%, transparent 100%)` }}>
            <h3 onClick={() => setGiftOpened(stuff.ref)} className={"result_gift_name"}> <u>{stuff.Gift}</u></h3>
            <h3>{percentage + "%"} </h3>
          </div>
        </>
      );
};

export default Item;
